export default {
      id: "txt_bold-usage",
      viewBox: "0 0 12 16",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_bold",
      toString: function () {
        return this.url;
      }
    }